import axios from 'axios';
import {
  Filters,
} from '../../implementation-specialist/models/reportsFilters';
import {configSettings} from '../../shared/configuration/config-settings';
import {Column} from '../../shared/model/column';
import {AxiosResultStatus} from '../../shared/service/axios-result-status';
import {axiosSaveHelper} from '../../shared/service/axios-save-helper';
import {AxiosSavePayload} from '../../shared/service/axios-save-payload';
import {ReportsInfo} from '../models/reports-info';
import {UserInfo} from '../models/user-info';
import {UserInfoRole} from '../models/user-info-role';


export const adminUserHelper = {

  mapToColumns (dataReports: ReportsInfo): Column[]{
    let columns: Column[] = [];
    dataReports.headers.forEach(header=> {
      const id = header.columnName.replaceAll(" ","");
      const type = header.dataType
      const column = {
        id,
        label: header.columnName,
        type
      } as Column
      columns.push(column)
    })
    return columns
  },

  mapToData(columns: Column[], dataReports: ReportsInfo) {
    const reports:any =[]
    dataReports.data.forEach(report=>{
      // This generates and empty object each time with the keys from the columns array
      const obj:any = {}
      columns.forEach(column => {
        obj[column.id] = ""
      })
      // The data is asigned to the empty object created
      report.forEach((reportData, index)=>{
          obj[columns[index].id] = reportData
      })
      reports.push(obj)
    })
    return reports
  },


  mapWorkflowIds(workFlowStatusIds: number[], workFlowSubStatusIds: number[], IdsArray: string[]){
    IdsArray.forEach(IdsString => {
      let IdArray = IdsString.split(',')
      if(!workFlowStatusIds.includes(Number(IdArray[0]))){
        workFlowStatusIds.push(Number(IdArray[0]))
      }

      if(!workFlowSubStatusIds.includes(Number(IdArray[1]))){
        workFlowSubStatusIds.push(Number(IdArray[1]))
      }
    })

    return{workFlowStatusIds, workFlowSubStatusIds }


  },

  mapRiskIds(payorRiskIds: number[], timingRiskIds: number[], IdsArray: string[]){
    IdsArray.forEach(IdsString => {
      let IdArray = IdsString.split(',')
      if(!payorRiskIds.includes(Number(IdArray[0]))){
        payorRiskIds.push(Number(IdArray[0]))
      }

      if(!timingRiskIds.includes(Number(IdArray[1]))){
        timingRiskIds.push(Number(IdArray[1]))
      }
    })


    return{payorRiskIds, timingRiskIds}

  },

  mapAllRiskIds(initialRiskIds: number[], modifiedRiskIds: number[], convertedRiskIds: number[], finalRiskIds: number[], initialIdsArray: string[], modifiedIdsArray: string[], convertedIdsArray: string[], finalIdsArray: string[]){
    initialIdsArray.forEach(IdsString => {
      let IdArray = IdsString.split(",");
      if(!initialRiskIds.includes(Number(IdArray[0]))){
        initialRiskIds.push(Number(IdArray[0]));
      }
    })
    modifiedIdsArray.forEach(IdsString => {
      let IdArray = IdsString.split(",");
      if(!modifiedRiskIds.includes(Number(IdArray[0]))){
        modifiedRiskIds.push(Number(IdArray[0]));
      }
    })
    convertedIdsArray.forEach(IdsString => {
      let IdArray = IdsString.split(",");
      if(!convertedRiskIds.includes(Number(IdArray[0]))){
        convertedRiskIds.push(Number(IdArray[0]));
      }
    })
    finalIdsArray.forEach(IdsString => {
      let IdArray = IdsString.split(",");
      if(!finalRiskIds.includes(Number(IdArray[0]))){
        finalRiskIds.push(Number(IdArray[0]));
      }
    })

    return {initialRiskIds, modifiedRiskIds, convertedRiskIds, finalRiskIds}
  }


}

export class AdminUserService {

  async getReportsInfo(reportsFilters: Filters, offset: number, limit: number): Promise<AxiosResultStatus>  {
    const includeFacilityTotals: boolean = reportsFilters.includeFacilityTotals!;
    if (reportsFilters.reportType === 'SummaryTransactions') {
      delete reportsFilters.includeFacilityTotals;
    }

    const dataToSave ={
      filters: reportsFilters
    }

    let paramId;
    let reportsURL;

    switch(reportsFilters.reportType){
      case 'AllInstanceofCare':
        reportsURL= `patient-encounter/v2/IoCReport?offset=${offset}&limit=${limit}`;
        paramId = 0;
        break;
      case 'SummaryTransactions':
        reportsURL = `payment/v2/transactionReport?includeFacilityTotals=${includeFacilityTotals}&offset=${offset}&limit=${limit}`;
        paramId = 0;
        break;
      case "MergedTransactions":
        reportsURL = `payment/v2/mergedTransactionReport?offset=${offset}&limit=${limit}`;
        paramId = 0;
        break;
      case "AutomatedPayment":
        reportsURL = `payment/v2/automatedPaymentReport?offset=${offset}&limit=${limit}`;
        paramId = 0;
        break;
      case "SettlementSummary":
        reportsURL = `payment/v2/settlementReport?offset=${offset}&limit=${limit}`;
        paramId = 0;
        break;
      case 'PESActivityLog':
        reportsURL = `patient-encounter/v2/report?offset=${offset}&limit=${limit}`;
        paramId = 0
        break;
      case 'SettlementDetail':
        reportsURL= `payment/v2/report?offset=${offset}&limit=${limit}`;
        paramId = -2;
        break;
      default:
        reportsURL = `reports/?offset=${offset}&limit=${limit}`;
        paramId = 0;
    }

    const payload: AxiosSavePayload = {
      dataToSave: dataToSave,
      dataId: paramId,
      url: reportsURL
    }
    return await axiosSaveHelper(payload);
  }

  async getPaymentChannels() {
    const responseAPI = await axios.get(`${configSettings.unified_aws_app_gateway_uri}/payment/v2/payment/paymentchannels`);
    const paymentChannels = responseAPI.data;
    return paymentChannels;
  }

  async getv2Reports(dashboardId: number) {
    const responseAPI = await axios.get(`${configSettings.unified_aws_app_gateway_uri}/report/v2/report/${dashboardId}`);
    const reports = responseAPI.data;
    return reports;
  }

  async getAllv2Reports() {
    const responseAPI = await axios.get(`${configSettings.unified_aws_app_gateway_uri}/report/v2/report`);
    const reports = responseAPI.data;
    return reports;
  }

  async createOrUpdateUser(data: Partial<Omit<UserInfo, 'userRole'>> & { userRole?: Partial<UserInfoRole>, lastLoginDt?: string}): Promise<AxiosResultStatus> {
    const payload: AxiosSavePayload = {
      dataToSave: data,
      dataId: data.userId ? data.userId : 0,
      url: "user/v2/user",

    }
    return await axiosSaveHelper(payload);
  }

}

export const userService = new AdminUserService();

